// 汇率 (1人民币 = 12.5卢布)
export const EXCHANGE_RATE = 12.5;

// 国际运费计算规则
export const INTERNATIONAL_SHIPPING_RATES = [  {
    minPrice: 0,
    maxPrice: 1500,
    minWeight: 1,
    maxWeight: 500,
    baseFee: 3,
    ratePerGram: 0.035,
    maxDimension: 60,
    maxGirth: 90,
  },
  {
    minPrice: 0,
    maxPrice: 1500,
    minWeight: 501,
    maxWeight: 25000,
    baseFee: 23,
    ratePerGram: 0.025,
    maxGirth: 90,
  },
  {
    minPrice: 1501,
    maxPrice: 7000,
    minWeight: 1,
    maxWeight: 2000,
    baseFee: 16,
    ratePerGram: 0.025,
    maxGirth: 90,
  },
  {
    minPrice: 1501,
    maxPrice: 7000,
    minWeight: 2001,
    maxWeight: 25000,
    baseFee: 36,
    ratePerGram: 0.025,
    maxDimension: 150,
    maxGirth: 250,
  },
  {
    minPrice: 7001,
    maxPrice: 250000,
    minWeight: 1,
    maxWeight: 5000,
    baseFee: 22,
    ratePerGram: 0.025,
    maxDimension: 150,
    maxGirth: 250,
  },
  {
    minPrice: 7001,
    maxPrice: 250000,
    minWeight: 5001,
    maxWeight: 25000,
    baseFee: 62,
    ratePerGram: 0.028,
    maxDimension: 150,
    maxGirth: 250,
  },
];

// 国内运费计算规则
export const DOMESTIC_SHIPPING_RATES = {
  firstKg: 15,      // 首重1kg价格
  additionalPerKg: 6, // 续重每kg价格
  firstWeight: 1000,  // 首重克数
};

// 平台佣金比例
export const PLATFORM_COMMISSION_RATES = {
  pet: {
    standard: {
      below1500: 0.12,
      above1500: 0.15,
    },
    border: {
      below1500: 0.11,
      above1500: 0.14,
    },
  },
  tool: {
    standard: {
      below1500: 0.12,
      above1500: 0.18,
    },
    border: {
      below1500: 0.11,
      above1500: 0.17,
    },
  },
} as const;
